import { type Schedule } from "@repo/api";
import { addMinutes, isAfter, isBefore } from "date-fns";

import { sortSchedule } from "./sortSchedules";
import { isScheduleWork } from "./utils";

export const getWorkhours = (
  schedules: Schedule[] | undefined,
  emailId: string,
  enableWorkhours?: boolean
) => {
  // If not enabled or if NO schedules exists (different from [])
  if (!enableWorkhours || !schedules) {
    return {
      isWorking: true,
      startTime: undefined,
      endTime: undefined,
      tasks: [],
    };
  }

  const regularWork = schedules
    .filter((i) => i.coworkerEmail.toLowerCase() === emailId.toLowerCase())
    .filter(isScheduleWork)
    .sort(sortSchedule);

  if (regularWork.length === 0) {
    return {
      isWorking: false,
      startTime: undefined,
      endTime: undefined,
      tasks: regularWork,
    };
  }

  const startTime = new Date(
    Math.min(
      ...regularWork.map((schedule) =>
        new Date(schedule.shiftStartTime).getTime()
      )
    )
  );
  const endTime = new Date(
    Math.max(
      ...regularWork.map((schedule) =>
        new Date(schedule.shiftEndTime).getTime()
      )
    )
  );

  return {
    isWorking: true,
    startTime,
    endTime,
    tasks: regularWork,
  };
};

export const isWorking = (workHours: WorkHours, date: Date) => {
  if (!workHours.isWorking) {
    return false;
  }

  if (workHours.startTime && isBefore(date, workHours.startTime)) {
    return false;
  }

  if (workHours.endTime && isAfter(date, addMinutes(workHours.endTime, -1))) {
    return false;
  }

  return true;
};

export type WorkHours = ReturnType<typeof getWorkhours>;
